module.exports = __webpack_public_path__ + "static/media/EC.ca34fc75.svg";